<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">{{ $t('quotation_item_remove_tab_item') }} </v-tab>
      <v-tab href="#tab-2"> {{ $t('quotation_item_remove_tab_month_item') }}</v-tab>
      <v-tab href="#tab-3"> {{ $t('quotation_item_remove_tab_pay_item') }}</v-tab>
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="removeItemDataTableHeaders"
              :items="computedRemoveItemList"
              :search="searchRemoveItem"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              disable-pagination
              hide-default-footer
              item-key="Index"
              show-select
              v-model="selectedRemoveItems"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{
                    $t('quotation_item_remove_car_customer_fix_title')
                  }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchRemoveItem"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    @click="deleteRemoveItems"
                    :disabled="isAllTextFieldDisabled || selectedRemoveItems.length === 0"
                  >
                    {{ $t('common_delete') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    @click="isShowRemoveItemDialog = true"
                    :disabled="isAllTextFieldDisabled"
                  >
                    {{ $t('common_new') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowRemoveItemDialog"
                    v-if="isShowRemoveItemDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ removeItemDialogTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialog">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('installation_notice_item_buy_or_rent')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="editedRemoveItem.BuyOrRentType"
                                    :items="allBuyOrRentType"
                                    item-text="Name"
                                    item-value="Type"
                                    required
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    ref="buyOrRentTypeAutocomplete"
                                    @keyup.enter="setBuyOrRentType"
                                    :error-messages="errors[0]"
                                    :disabled="
                                      editedRemoveItem.Type === 'Z100000000' ||
                                        editedRemoveItemIndex !== -1
                                    "
                                    @change="changeBuyOrRentType"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('installation_notice_item_buy_or_rent') }}
                                    </template>
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <quotation-item-for-repair-price-autocomplete
                                  :fatherEditedItem="editedRemoveItem"
                                  :editedItemIndex="editedRemoveItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="repairCustomerId"
                                  :customerDeviceType="editedRemoveItem.CustomerDeviceType"
                                  @setEditedItem="setEditedItem"
                                  v-if="
                                    editedRemoveItemIndex === -1 &&
                                      (editedRemoveItem.BuyOrRentType === 2 ||
                                        editedRemoveItem.BuyOrRentType === 3)
                                  "
                                  @keyupEnter="focusNextInput"
                                  refName="itemAutocomplete"
                                />
                                <quotation-item-autocomplete
                                  :fatherEditedItem="editedRemoveItem"
                                  :editedItemIndex="editedRemoveItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :customerDeviceType="editedRemoveItem.CustomerDeviceType"
                                  @setEditedItem="setEditedItem"
                                  v-else-if="
                                    editedRemoveItemIndex === -1 &&
                                      editedRemoveItem.BuyOrRentType === 1
                                  "
                                  refName="itemAutocomplete"
                                  @keyupEnter="focusNextInput"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedRemoveItem.Number"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedRemoveItem.Name"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('quotation_remove_item_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedRemoveItem.Quantity"
                                    required
                                    :disabled="
                                      editedRemoveItem.HasSerialNumber ||
                                        editedRemoveItem.InstallPosition > 0
                                    "
                                    @keyup.enter="focusNextInput"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_remove_item_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedRemoveItem.Unit"
                                    required
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <v-autocomplete
                                  v-model="editedRemoveItem.InstallPosition"
                                  :items="allInstallPositionType"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('quotation_item_install_position')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  ref="installPositionAutocomplete"
                                  @keyup.enter="setInstallPosition"
                                  @change="setInstallPositionQuantity"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <v-checkbox
                                  v-model="editedRemoveItem.IsCustomerDevice"
                                  :label="$t('quotation_item_is_customer_device')"
                                  @change="changeIsCustomerDevice"
                                  :disabled="editedRemoveItem.BuyOrRentType === 1"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedRemoveItem.CustomerDeviceType"
                                  :items="customerDeviceTypeList"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('engineer_item_customer_device_type')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-if="editedRemoveItem.IsCustomerDevice"
                                  ref="deviceTypeAutocomplete"
                                  @keyup.enter="setCustomerDeviceType"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedRemoveItem.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedRemoveItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedRemoveItem">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    @click="isShowRemoveCarEditedBomDialog = true"
                    :disabled="isAllTextFieldDisabled"
                  >
                    {{ $t('quotation_item_new_install_new_bom_btn') }}
                  </v-btn>
                  <v-dialog
                    v-if="isShowRemoveCarEditedBomDialog"
                    v-model="isShowRemoveCarEditedBomDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5"></span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="bomRepairItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('installation_notice_item_buy_or_rent')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="editedRemoveCarBomItem.BuyOrRentType"
                                    :items="allBuyOrRentType"
                                    item-text="Name"
                                    item-value="Type"
                                    required
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    ref="buyOrRentTypeAutocomplete"
                                    @keyup.enter="setBuyOrRentType"
                                    :error-messages="errors[0]"
                                    @change="changeBuyOrRentType"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('installation_notice_item_buy_or_rent') }}
                                    </template>
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                lg="3"
                                xl="3"
                                v-if="editedRemoveCarBomItem.BuyOrRentType === 1"
                              >
                                <quotation-bom-autocomplete
                                  :fatherEditedItem="editedRemoveCarBomItem"
                                  :editedItemIndex="editedRemoveItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="repairCustomerId"
                                  :customerDeviceType="editedRemoveCarBomItem.CustomerDeviceType"
                                  @setBomItem="setBomItem"
                                  v-if="editedRemoveItemIndex === -1"
                                  @keyupEnter="focusNextInput"
                                  refName="bomNameAutocomplete"
                                />
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3" v-else>
                                <quotation-bom-for-repair-price-autocomplete
                                  :fatherEditedItem="editedRemoveCarBomItem"
                                  :editedItemIndex="editedRemoveItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="repairCustomerId"
                                  :customerDeviceType="editedRemoveCarBomItem.CustomerDeviceType"
                                  @setBomItem="setBomItem"
                                  v-if="editedRemoveItemIndex === -1"
                                  @keyupEnter="focusNextInput"
                                  refName="bomNameAutocomplete"
                                />
                              </v-col>
                              <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedRemoveCarBomItem.Describe"
                                  disabled
                                  label="主設備描述"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedRemoveCarBomItem.Quantity"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedRemoveCarBomItem.InstallPositions"
                                  :items="allInstallPositionType"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('quotation_item_install_position')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  small-chips
                                  multiple
                                  @change="setInstallPositionListQuantity"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                                <v-checkbox
                                  v-model="editedRemoveCarBomItem.IsCustomerDevice"
                                  :label="$t('quotation_item_is_customer_device')"
                                  @change="changeIsCustomerDevice"
                                  :disabled="editedRemoveCarBomItem.BuyOrRentType === 1"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedRemoveCarBomItem.CustomerDeviceType"
                                  :items="customerDeviceTypeList"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('engineer_item_customer_device_type')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-if="editedRemoveCarBomItem.IsCustomerDevice"
                                  ref="deviceTypeAutocomplete"
                                  @keyup.enter="setCustomerDeviceType"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="red darken-1"
                          text
                          @click="closeRemoveCarEditedBomDialog"
                          :disabled="isAllTextFieldDisabled"
                        >
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="addRemoveCarBomItem">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeleteRemoveItemDialog"
                    :deleteMessage="'quotation_item_remove_car_customer_fix_delete_title'"
                    @closeDelete="closeDeleteRemoveItem"
                    @confirmDelete="confirmDeleteRemoveItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-icon
                  small
                  @click="isShowEditedRemoveItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="isShowDeleteRemoveItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:[`item.InstallPosition`]="{ item }">
                {{ turnData(item.InstallPosition) }}
              </template>
              <template v-slot:[`item.BuyOrRentType`]="{ item }">
                {{ turnBuyOrRentType(item.BuyOrRentType) }}
              </template>
              <template v-slot:[`item.Move`]="{ item, index }">
                <v-btn
                  icon
                  @click="upRemoveItem(item)"
                  v-if="index !== 0"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-up-drop-circle-outline
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="downRemoveItem(item)"
                  v-if="index !== computedRemoveItemList.length - 1"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-down-drop-circle-outline
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <remove-month-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :carQuantity="carQuantity"
          :allPayType="allPayType"
          :allPayQuantityType="allPayQuantityType"
          @setAllMonth="setAllMonth"
          @setMonthItemIndex="setMonthItemIndex"
          @setMonthItem="setMonthItem"
          @deleteMonthItem="deleteMonthItem"
        />
      </v-tab-item>
      <v-tab-item value="tab-3">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="payItemDataTableHeaders"
              :items="payItemList"
              :search="searchPayItem"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              item-key="Name"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{
                    $t('quotation_item_remove_tool_bar_title')
                  }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchPayItem"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    :disabled="isAllTextFieldDisabled"
                    @click="openPayItem"
                  >
                    {{ $t('quotation_item_new_install_new_item_btn') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowEditPayItemDialog"
                    v-if="isShowEditPayItemDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ $t('quotation_item_remove_pay') }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogPayItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <pay-item-autocomplete
                                  :fatherEditedItem="editedPayItem"
                                  :editedItemIndex="editedPayItemIndex"
                                  :itemName="'quotation_item_number'"
                                  @setEditedPayItem="setEditedPayItem"
                                  v-if="editedPayItemIndex === -1"
                                  refName="monthItemAutocomplete"
                                  @keyupEnter="focusNextInput"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Number"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Name"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_car_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.BuyQuantity"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_car_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Unit"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Price"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Discount"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣後單價"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.DiscountPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣後單價
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.TotalPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedPayItem.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedPayItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedPayItem">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeletePayItemDialog"
                    :deleteMessage="'quotation_item_delete_item_dialog_title'"
                    @closeDelete="closeDeletePayItem"
                    @confirmDelete="confirmDeletePayItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-btn
                  icon
                  @click="isShowEditPayItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="isShowDeletePayItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.Move`]="{ item, index }">
                <v-btn
                  icon
                  @click="upPayItem(item)"
                  v-if="index !== 0"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-up-drop-circle-outline
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="downPayItem(item)"
                  v-if="index !== payItemList.length - 1"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon>
                    mdi-arrow-down-drop-circle-outline
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import { extend } from 'vee-validate'
import { regex } from 'vee-validate/dist/rules'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { HttpInstallPosition, HttpInstallationAcceptance, HttpQuotation } from '@/js/http-Manager'
import { BuyOrRentType } from '@/js/BuyOrRentType'
import PayItemAutocomplete from '@/components/PayItemAutocomplete.vue'
import QuotationItemForRepairPriceAutocomplete from '@/components/Quotation/ItemAutocomplete/QuotationItemForRepairPriceAutocomplete.vue'
import QuotationItemAutocomplete from '@/components/Quotation/ItemAutocomplete/QuotationItemAutocomplete.vue'
import QuotationBomForRepairPriceAutocomplete from '@/components/Quotation/BomAutocomplete/QuotationBomForRepairPriceAutocomplete.vue'
import QuotationBomAutocomplete from '@/components/Quotation/BomAutocomplete/QuotationBomAutocomplete.vue'
import RemoveMonthSetting from '@/components/Quotation/MonthItem/RemoveMonthSetting.vue'
extend('regex', regex)

export default {
  components: {
    DeleteDialog,
    PayItemAutocomplete,
    QuotationItemForRepairPriceAutocomplete,
    QuotationItemAutocomplete,
    QuotationBomForRepairPriceAutocomplete,
    QuotationBomAutocomplete,
    RemoveMonthSetting
  },
  name: 'RemoveCar',
  data: () => ({
    isShowRemoveCarEditedBomDialog: false,
    isShowRemoveItemDialog: false,
    editedRemoveItemIndex: -1,
    searchQuotationRemoveCar: '',
    editedRemoveItem: {
      BomName: '',
      Id: '',
      Number: '',
      Name: '',
      Unit: '',
      Quantity: 0,
      BuyOrRentType: 0,
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      IsCustomerDevice: false,
      InstallPosition: 0,
      Custody: 0,
      Remark: '',
      HasSerialNumber: false,
      CustomerDeviceType: 0
    },
    defaultRemoveItem: {
      BomName: '',
      ItemId: '',
      Number: '',
      Name: '',
      Unit: '',
      Quantity: 0,
      BuyOrRentType: 0,
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      IsCustomerDevice: false,
      InstallPosition: 0,
      Custody: 0,
      Remark: '',
      HasSerialNumber: false,
      CustomerDeviceType: 0
    },
    searchRemoveItem: '',
    allInstallPositionType: [],
    allBuyOrRentType: [],
    customerDeviceTypeList: [],
    isShowDeleteRemoveItemDialog: false,
    searchPayItem: '',
    isShowEditPayItemDialog: false,
    editedPayItem: {
      Id: '',
      Number: '',
      Name: '',
      BuyQuantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0
    },
    defaultPayItem: {
      Id: '',
      Number: '',
      Name: '',
      BuyQuantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0
    },
    editedPayItemIndex: -1,
    isShowDeletePayItemDialog: false,

    editedRemoveCarBomItem: {
      Name: '',
      Describe: '',
      BuyOrRentType: 0,
      Quantity: 1,
      InstallPositions: [],
      BomItems: [],
      IsCustomerDevice: false,
      CustomerDeviceType: 0
    },
    defaultRemoveCarBomItem: {
      Name: '',
      Describe: '',
      BuyOrRentType: 0,
      Quantity: 1,
      InstallPositions: [],
      BomItems: [],
      IsCustomerDevice: false,
      CustomerDeviceType: 0
    },
    selectedRemoveItems: [],
    regexPrice: /^[0-9]+$/,
    regexQuantity: /^[0-9]+$/
  }),
  async mounted () {
    await this.getAllInstallPositionType()
    await this.getBuyOrRentType()
    await this.getCustomerDeviceType()
  },
  computed: {
    computedRemoveItemList () {
      let array = []
      this.removeItemList.forEach((element, index) => {
        array.push(Object.assign({ Index: index }, element))
      })
      return array
    },
    removeItemDialogTitle () {
      return this.editedRemoveItemIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    removeItemDataTableHeaders () {
      return [
        { text: this.$t('installation_notice_item_main_name'), align: 'start', value: 'BomName' },
        { text: '主設備描述', align: 'start', value: 'BomDescribe' },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'center',
          value: 'BuyOrRentType'
        },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_remove_item_quantity'), align: 'end', value: 'Quantity' },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'IsCustomerDevice'
        },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false }
      ]
    },
    payItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_car_quantity'), align: 'end', value: 'BuyQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false }
      ]
    }
  },
  watch: {},
  methods: {
    setAllMonth (temp) {
      this.$emit('setAllMonth', temp)
    },
    setMonthItemIndex (index) {
      this.$emit('setMonthItemIndex', index)
    },
    setMonthItem (val) {
      this.$emit('setMonthItem', val)
    },
    deleteMonthItem () {
      this.$emit('deleteMonthItem')
    },
    setInstallPositionQuantity () {
      if (this.editedRemoveItem.InstallPosition) {
        this.editedRemoveItem.Quantity = 1
      }
    },

    deleteRemoveItems () {
      let array = []
      this.computedRemoveItemList.forEach((element) => {
        let isExist =
          this.selectedRemoveItems.findIndex(
            (x) =>
              x.BomName === element.BomName &&
              x.InstallPosition === element.InstallPosition &&
              x.Id === element.Id
          ) !== -1
        if (!isExist) {
          array.push(element)
        }
      })

      this.$emit('setRemove', array)
      this.selectedRemoveItems = []
    },
    setBomItem (val) {
      if (this.editedRemoveCarBomItem) {
        this.editedRemoveCarBomItem.Id = val.Id
        this.editedRemoveCarBomItem.Name = val.Name
        this.editedRemoveCarBomItem.Describe = val.Describe
        this.editedRemoveCarBomItem.BomItems = val.BomItems
      } else {
        this.editedRemoveCarBomItem.Id = ''
        this.editedRemoveCarBomItem.Name = ''
        this.editedRemoveCarBomItem.Describe = ''
        this.editedRemoveCarBomItem.BomItems = []
      }

      this.editedRemoveCarBomItem = JSON.parse(JSON.stringify(this.editedRemoveCarBomItem))
    },
    changeBuyOrRentType () {
      this.editedRemoveItem.Name = ''
      this.editedRemoveCarBomItem.Name = ''
      this.editedRemoveCarBomItem.Id = ''
      this.editedRemoveCarBomItem.Describe = ''
      this.editedRemoveCarBomItem.BomItems = []
      this.editedRemoveItem.Unit = ''
      if (this.editedRemoveItem.BuyOrRentType === 1) {
        this.editedRemoveItem.IsCustomerDevice = true
        this.editedRemoveItem.CustomerDeviceType = 3
      } else if (this.editedRemoveCarBomItem.BuyOrRentType === 1) {
        this.editedRemoveCarBomItem.IsCustomerDevice = true
        this.editedRemoveCarBomItem.CustomerDeviceType = 3
      }
    },
    async addRemoveCarBomItem () {
      const isValid = await this.$refs.bomRepairItem.validate()
      if (isValid) {
        this.computedRemoveItemList.forEach((element) => {
          if (
            this.editedRemoveCarBomItem.Id === element.BomId &&
            this.editedRemoveCarBomItem.BuyOrRentType === element.BuyOrRentType
          ) {
            let index = this.editedRemoveCarBomItem.BomItems.findIndex((x) => x.Id === element.Id)
            if (index !== -1) {
              if (
                this.editedRemoveCarBomItem.InstallPositions &&
                this.editedRemoveCarBomItem.InstallPositions.length > 0
              ) {
                let idx = this.editedRemoveCarBomItem.InstallPositions.findIndex(
                  (x) => x === element.InstallPosition
                )
                if (idx !== -1) {
                  this.editedRemoveCarBomItem.InstallPositions.splice(idx, 1)
                  this.editedRemoveCarBomItem.Quantity--
                  if (this.editedRemoveCarBomItem.InstallPositions.length === 0) {
                    this.editedRemoveCarBomItem.BomItems.splice(index, 1)
                  }
                }
              } else {
                this.editedRemoveCarBomItem.BomItems.splice(index, 1)
              }
            }
          }
        })

        if (this.editedRemoveCarBomItem.BomItems.length !== 0) {
          if (
            this.editedRemoveCarBomItem.InstallPositions &&
            this.editedRemoveCarBomItem.InstallPositions.length > 0
          ) {
            this.editedRemoveCarBomItem.InstallPositions.forEach((ele) => {
              this.editedRemoveCarBomItem.BomItems.forEach((element) => {
                this.$emit('setRemoveCarIndex', -1)
                this.$emit('setEditRemoveCar', {
                  BomName: this.editedRemoveCarBomItem.Name,
                  BomId: this.editedRemoveCarBomItem.Id,
                  BomDescribe: this.editedRemoveCarBomItem.Describe,
                  Id: element.Id,
                  Number: element.Number,
                  Name: element.Name,
                  Unit: element.Unit,
                  Quantity:
                    (element.Quantity * this.editedRemoveCarBomItem.Quantity * 1) /
                    this.editedRemoveCarBomItem.InstallPositions.length,
                  BuyOrRentType: this.editedRemoveCarBomItem.BuyOrRentType,
                  SerialNumber: {
                    ItemId: '',
                    Number: '',
                    IsUsed: false,
                    AcceptanceNumber: '',
                    RepairNumber: ''
                  },
                  IsCustomerDevice: this.editedRemoveCarBomItem.IsCustomerDevice,
                  InstallPosition: ele,
                  Custody: 0,
                  Remark: '',
                  HasSerialNumber: element.HasSerialNumber,
                  CustomerDeviceType: this.editedRemoveCarBomItem.CustomerDeviceType
                })
              })
            })
          } else {
            this.editedRemoveCarBomItem.BomItems.forEach((element) => {
              this.$emit('setRemoveCarIndex', -1)
              this.$emit('setEditRemoveCar', {
                BomName: this.editedRemoveCarBomItem.Name,
                BomId: this.editedRemoveCarBomItem.Id,
                BomDescribe: this.editedRemoveCarBomItem.Describe,
                Id: element.Id,
                Number: element.Number,
                Name: element.Name,
                Unit: element.Unit,
                Quantity: element.Quantity * this.editedRemoveCarBomItem.Quantity * 1,
                BuyOrRentType: this.editedRemoveCarBomItem.BuyOrRentType,
                SerialNumber: {
                  ItemId: '',
                  Number: '',
                  IsUsed: false,
                  AcceptanceNumber: '',
                  RepairNumber: ''
                },
                IsCustomerDevice: this.editedRemoveCarBomItem.IsCustomerDevice,
                InstallPosition: element.InstallPosition,
                Custody: 0,
                Remark: '',
                HasSerialNumber: element.HasSerialNumber,
                CustomerDeviceType: this.editedRemoveCarBomItem.CustomerDeviceType
              })
            })
          }
        }

        this.closeRemoveCarEditedBomDialog()
      }
    },
    closeRemoveCarEditedBomDialog () {
      this.isShowRemoveCarEditedBomDialog = false
      let str = JSON.stringify(this.defaultRemoveCarBomItem)
      this.editedRemoveCarBomItem = JSON.parse(str)
    },
    setInstallPositionListQuantity () {
      this.editedRemoveCarBomItem.Quantity = this.editedRemoveCarBomItem.InstallPositions.length
      this.editedRemoveCarBomItem = JSON.parse(JSON.stringify(this.editedRemoveCarBomItem))
    },
    setCustomerDeviceType (event) {
      this.$refs.deviceTypeAutocomplete.isMenuActive = false
      this.$refs.deviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setInstallPosition (event) {
      this.$refs.installPositionAutocomplete.isMenuActive = false
      this.$refs.installPositionAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setBuyOrRentType (event) {
      this.$refs.buyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.buyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    downPayItem (item) {
      let temp = JSON.parse(JSON.stringify(this.payItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setAllPay', temp)
    },
    upPayItem (item) {
      let temp = JSON.parse(JSON.stringify(this.payItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setAllPay', temp)
    },

    downRemoveItem (item) {
      let temp = JSON.parse(JSON.stringify(this.computedRemoveItemList))
      let currentIndex = item.HasSerialNumber
        ? temp.findIndex(
          (x) =>
            x.Id === item.Id &&
              x.BomId === item.BomId &&
              x.InstallPosition === item.InstallPosition &&
              x.SerialNumber.Number === item.SerialNumber.Number
        )
        : temp.findIndex(
          (x) =>
            x.Id === item.Id &&
              x.BomId === item.BomId &&
              x.InstallPosition === item.InstallPosition
        )
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setRemove', temp)
    },
    upRemoveItem (item) {
      let temp = JSON.parse(JSON.stringify(this.computedRemoveItemList))
      let currentIndex = item.HasSerialNumber
        ? temp.findIndex(
          (x) =>
            x.Id === item.Id &&
              x.BomId === item.BomId &&
              x.InstallPosition === item.InstallPosition &&
              x.SerialNumber.Number === item.SerialNumber.Number
        )
        : temp.findIndex(
          (x) =>
            x.Id === item.Id &&
              x.BomId === item.BomId &&
              x.InstallPosition === item.InstallPosition
        )
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setRemove', temp)
    },
    setEditedPayItem (val) {
      this.editedPayItem.Id = val.Id
      this.editedPayItem.Number = val.Number
      this.editedPayItem.Name = val.Name
      this.editedPayItem.Unit = val.Unit
      this.editedPayItem.Price = val.Price
      this.editedPayItem.IsDelete = val.IsDelete
      this.editedPayItem.StoreNo = val.StoreNo
      this.changePayTotal()
      this.editedPayItem = JSON.parse(JSON.stringify(this.editedPayItem))
    },
    closeEditedPayItem () {
      this.isShowEditPayItemDialog = false
      this.editedPayItem = JSON.parse(JSON.stringify(this.defaultPayItem))
      this.editedPayItemIndex = -1
    },
    openPayItem () {
      this.editedPayItem.BuyQuantity = this.carQuantity
      this.isShowEditPayItemDialog = true
    },
    isShowEditPayItemDialogBtn (item) {
      this.editedPayItemIndex = this.payItemList.indexOf(item)
      this.editedPayItem = JSON.parse(JSON.stringify(item))
      this.isShowEditPayItemDialog = true
    },
    async saveEditedPayItem () {
      const isValid = await this.$refs.dialogPayItem.validate()
      if (isValid) {
        this.$emit('setPayItemIndex', this.editedPayItemIndex)
        this.$emit('setPayItem', this.editedPayItem)
        this.closeEditedPayItem()
      }
    },
    isShowDeletePayItemDialogBtn (item) {
      this.editedPayItemIndex = this.payItemList.indexOf(item)
      this.isShowDeletePayItemDialog = true
    },
    closeDeletePayItem () {
      this.editedPayItemIndex = -1
      this.isShowDeletePayItemDialog = false
    },
    confirmDeletePayItem () {
      this.$emit('deletePayItem', this.editedPayItemIndex)
      this.closeDeletePayItem()
    },
    changePayTotal () {
      if (
        this.regexPrice.test(this.editedPayItem.Price) &&
        this.regexQuantity.test(this.editedPayItem.BuyQuantity) &&
        this.regexQuantity.test(this.editedPayItem.Discount) &&
        this.regexQuantity.test(this.editedPayItem.DiscountPrice)
      ) {
        this.editedPayItem.DiscountPrice = this.editedPayItem.Price - this.editedPayItem.Discount
        this.editedPayItem.TotalPrice =
          this.editedPayItem.BuyQuantity * this.editedPayItem.DiscountPrice * 1
      }
    },
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : 0
    },
    changeIsCustomerDevice () {
      if (this.editedRemoveItem.IsCustomerDevice) {
        this.editedRemoveItem.CustomerDeviceType = 3
      } else {
        this.editedRemoveItem.CustomerDeviceType = 0
      }

      if (this.editedRemoveCarBomItem.IsCustomerDevice) {
        this.editedRemoveCarBomItem.CustomerDeviceType = 3
      } else {
        this.editedRemoveCarBomItem.CustomerDeviceType = 0
      }
    },
    async getAllInstallPositionType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionType = response.status === 200 ? response.data.Data : []
    },
    async getBuyOrRentType () {
      let response = await HttpInstallationAcceptance.GetBuyOrRentTypes()
      this.allBuyOrRentType = response.status === 200 ? response.data.Data : []
    },
    setEditedItem (val) {
      this.editedRemoveItem.Id = val.Id
      this.editedRemoveItem.Number = val.Number
      this.editedRemoveItem.Name = val.Name
      this.editedRemoveItem.Unit = val.Unit
      this.editedRemoveItem.Price = val.Price
      this.editedRemoveItem.IsMonthItem = val.IsMonthItem
      this.editedRemoveItem.IsDelete = val.IsDelete
      this.editedRemoveItem.StoreNo = val.StoreNo
      this.editedRemoveItem.RepairPrice = val.RepairPrice
      this.editedRemoveItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedRemoveItem.RentWarrantyPeriod = val.RentWarrantyPeriod
      this.editedRemoveItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedRemoveItem.HasSerialNumber = val.HasSerialNumber
      this.editedRemoveItem.Type = val.Type
      this.editedRemoveItem.BuyOrRentType =
        val.Type === 'Z100000000' ? 2 : this.editedRemoveItem.BuyOrRentType
      if (val.HasSerialNumber) {
        this.editedRemoveItem.Quantity = 1
      }
      this.editedRemoveItem = JSON.parse(JSON.stringify(this.editedRemoveItem))
    },
    turnData (value) {
      if (value) {
        return ItemInstallPositionType.getFormInstallPositionTypeName(
          value,
          this.allInstallPositionType
        )
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditedRemoveItemDialogBtn (item) {
      this.editedRemoveItemIndex = this.computedRemoveItemList.indexOf(item)
      this.editedRemoveItem = JSON.parse(JSON.stringify(item))
      this.isShowRemoveItemDialog = true
    },
    async saveEditedRemoveItem () {
      const isValid = await this.$refs.dialog.validate()
      if (isValid) {
        this.$emit('setRemoveCarIndex', this.editedRemoveItemIndex)
        this.$emit('setEditRemoveCar', this.editedRemoveItem)
        this.closeEditedRemoveItem()
      }
    },
    closeEditedRemoveItem () {
      this.isShowRemoveItemDialog = false
      this.$nextTick(() => {
        this.editedRemoveItem = JSON.parse(JSON.stringify(this.defaultRemoveItem))
        this.editedRemoveItemIndex = -1
      })
    },
    isShowDeleteRemoveItemDialogBtn (item) {
      this.editedRemoveItemIndex = this.computedRemoveItemList.indexOf(item)
      this.isShowDeleteRemoveItemDialog = true
    },
    confirmDeleteRemoveItem () {
      this.$emit('setRemoveCarDeleteIndex', this.editedRemoveItemIndex)
      this.closeDeleteRemoveItem()
    },
    closeDeleteRemoveItem () {
      this.isShowDeleteRemoveItemDialog = false
      this.$nextTick(() => {
        this.editedRemoveItemIndex = -1
      })
    }
  },
  props: [
    'removeItemList',
    'isAllTextFieldDisabled',
    'monthItemList',
    'payItemList',
    'carQuantity',
    'repairCustomerId',
    'allPayType',
    'allPayQuantityType'
  ]
}
</script>
